/**
 * Les personnes à contacter d'une société cliente : fonctions proposées, qui
 * voit les remises, et mise à jour de la fiche.
 */

/** Fonctions proposées pour une personne de la société cliente. */
export const FONCTIONS = ['Patron', 'Directeur', 'Technicien', 'Collaborateur', 'Factures'];

/**
 * Le directeur et les techniciens voient les remises de leur société une fois
 * leur compte ouvert ; les autres, le prix final seulement. Même règle que le
 * serveur.
 *
 * @param {string} [fonction] fonction de la personne
 * @returns {boolean} vrai pour un compte de responsable
 */
export function voitLesRemises(fonction) {
  const f = String(fonction || '')
    .trim()
    .toLowerCase();
  return ['direct', 'techni', 'patron', 'respons'].some((d) => f.startsWith(d));
}

/**
 * Remplace les personnes à contacter d'un client ; la fiche part au serveur
 * comme toute autre modification.
 *
 * @param {Function} setClients mise à jour de la collection des clients
 * @param {*} clientId client visé
 * @param {Function} calcul nouvelle liste depuis l'ancienne
 */
export function modifieContacts(setClients, clientId, calcul) {
  setClients((p) =>
    p.map((c) => (c.id === clientId ? { ...c, contacts: calcul(c.contacts || []) } : c)),
  );
}
